export const MANAGE_DISTRIBUTION = {
    CLOSE_DIALOG_BTN: "MANAGE_DISTRIBUTION_CLOSE_DIALOG_BTN",
};
